import React, { Component } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators
} from 'reactstrap';
import styles from './styles.module.scss';

class InstructorCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
      animating: false
    };

    this.setActiveIndex = this.setActiveIndex.bind(this);
    this.setAnimating = this.setAnimating.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goto = this.goto.bind(this);
    this.startAnimation = this.setAnimating.bind(this, true);
    this.exitAnimation = this.setAnimating.bind(this, false);
  }

  setActiveIndex(activeIndex) {
    this.setState({ activeIndex });
  }

  setAnimating(animating) {
    this.setState({ animating });
  }

  next() {
    const { learningCenters } = this.props;
    const { animating, activeIndex } = this.state;
    if (animating) return;
    const nextIndex = activeIndex === learningCenters.length - 1 ? 0 : activeIndex + 1;
    this.setActiveIndex(nextIndex);
  }

  previous() {
    const { learningCenters } = this.props;
    const { animating, activeIndex } = this.state;
    if (animating) return;
    const nextIndex = activeIndex === 0 ? learningCenters.length - 1 : activeIndex - 1;
    this.setActiveIndex(nextIndex);
  }

  goto(newIndex) {
    const { animating } = this.state;
    if (animating) return;
    this.setActiveIndex(newIndex);
  }

  render() {
    const { learningCenters, onViewMore, onSelect } = this.props;
    const { activeIndex } = this.state;
    const slides = learningCenters.map(learningCenter => (
      <CarouselItem
        key={learningCenter.id}
        onExiting={this.startAnimation}
        onExited={this.exitAnimation}
      >
        <div className={styles.instructorCarouselSlide}>
          <h3 className={styles.centerTitle}>{learningCenter.title}</h3>
          <div className={styles.mainRow}>
            <div className={styles.tldrColumn}>
              <img
                className={styles.roundImage}
                src={learningCenter.image_file_name}
                alt={learningCenter.instructor_first_name}
              />
              {learningCenter.instructor_credentials.slice(0, 2).map(cred => (
                <div key={cred} className={styles.credential}>{cred}</div>
              ))}
            </div>
            <div className={styles.mainColumn}>
              {learningCenter.instructor_quote && (
                <blockquote className={styles.instructorQuote}>
                  <p className={styles.innerQuote}>
                    {learningCenter.instructor_quote}
                  </p>
                </blockquote>
              )}
            </div>
          </div>
          <div className={styles.actionRow}>
            {onViewMore && (
              <button onClick={onViewMore(learningCenter.id)} className={styles.viewMore}>
                View More
              </button>
            )}
            {onSelect && (
              <button onClick={onSelect(learningCenter.id)} className={styles.selectButton}>
                Purchase
              </button>
            )}
          </div>
        </div>
      </CarouselItem>
    ));
    return (
      <Carousel
        activeIndex={activeIndex}
        next={this.next}
        previous={this.previous}
      >
        <CarouselIndicators
          items={learningCenters}
          activeIndex={activeIndex}
          onClickHandler={this.goto}
        />
        {slides}
        <CarouselControl
          className={styles.previous}
          direction="prev"
          directionText="Previous"
          onClickHandler={this.previous}
        />
        <CarouselControl
          className={styles.next}
          direction="next"
          directionText="Next"
          onClickHandler={this.next}
        />
      </Carousel>
    );
  }
}

export default InstructorCarousel;
